var _path, _a;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 4.82812C14.1074 4.97461 14.1074 5.0918 14.1074 5.23828C14.1074 9.31055 11.0312 13.9688 5.37695 13.9688C3.61914 13.9688 2.00781 13.4707 0.660156 12.5918C0.894531 12.6211 1.12891 12.6504 1.39258 12.6504C2.82812 12.6504 4.14648 12.1523 5.20117 11.332C3.85352 11.3027 2.71094 10.4238 2.33008 9.19336C2.53516 9.22266 2.71094 9.25195 2.91602 9.25195C3.17969 9.25195 3.47266 9.19336 3.70703 9.13477C2.30078 8.8418 1.24609 7.61133 1.24609 6.11719V6.08789C1.65625 6.32227 2.1543 6.43945 2.65234 6.46875C1.80273 5.91211 1.27539 4.97461 1.27539 3.91992C1.27539 3.33398 1.42188 2.80664 1.68555 2.36719C3.20898 4.21289 5.49414 5.44336 8.04297 5.58984C7.98438 5.35547 7.95508 5.12109 7.95508 4.88672C7.95508 3.1875 9.33203 1.81055 11.0312 1.81055C11.9102 1.81055 12.7012 2.16211 13.2871 2.77734C13.9609 2.63086 14.6348 2.36719 15.2207 2.01562C14.9863 2.74805 14.5176 3.33398 13.873 3.71484C14.4883 3.65625 15.1035 3.48047 15.6309 3.24609C15.2207 3.86133 14.6934 4.38867 14.1074 4.82812Z",
    fill: "#1DA1F2"
  })), _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "https://www.figma.com/design/wMbgHkRz2SmeuHAQ8J7z4k?node-id=66-483"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    y: -1.125,
    width: 15,
    height: 17.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/Link-2.e4fd1da3775c4ff1c88b2eea9342b08f.svg";
export { ForwardRef as ReactComponent };